export default (activeStates) => ({
    activeStates,
    states: document.getElementById('svg-brasil-map').getElementsByTagName('a'),

    init() {
        this.getActiveStates();

        this.$watch('activeStates', () => this.getActiveStates());
    },

    getActiveStates() {
        this.activeStates.forEach(activeState => {
            Array.from(this.states).forEach(state => {
                if(activeState == state.attributes.code.nodeValue) {
                    state.getElementsByTagName('path')[0].style.fill = '#313130'
                };
            })
        })
    },
})
